<template>
	<div class="sf-account-form">
		<div class="sf-account-form__header">
			<div class="sf-account__logo">
				<div class="blind">LOGO</div>
				<!-- <p class="title hd_head-24_1">{{ systemName }}</p> -->
			</div>
			<div class="sf-account__logo__title">{{ systemName }}</div>
		</div>
		<div class="sf-account-form__contents">
			<div class="sf-account-form__item">
				<div class="col-lg-10 sf-account-form__languages">
					<i class="icon-sf-lang"></i>
					<!-- 언어 설정 -->
					<select v-model="language">
						<option v-for="(item, index) in languageList" :key="index" :value="item.value">{{ item.label }}</option>
					</select>
				</div>
			</div>

			<div class="sf-account-form__item">
				<div class="col-lg-10">
					<div class="sf-account-form__title">
						<!-- <h2>Login</h2> -->
						<h2 class="hd_head-30_1">Login</h2>
					</div>
					<div class="sf-account-form__input">
						<!-- 다국어: 아이디를 입력해주세요. -->
						<span class="hd_head-18_1">ID</span>
						<el-input
							:placeholder="getMessage_('SWCC000455')"
							v-model="userId"
							autocomplete="on"
							@keyup.enter.native="loginAction"
							@input="e => input(e, 'userId')"
						/>
					</div>
				</div>
			</div>

			<div class="sf-account-form__item">
				<div class="col-lg-10">
					<div class="sf-account-form__input">
						<span class="hd_head-18_1">Password</span>
						<!--  다국어: 비밀번호를 입력해주세요. -->
						<el-input
							type="password"
							:placeholder="getMessage_('SWCC000456')"
							v-model="userPw"
							autocomplete="on"
							@keyup.enter.native="loginAction"
							@input="e => input(e, 'userPw')"
						/>
					</div>
				</div>
			</div>

			<div class="sf-account-form__item">
				<div class="col-lg-10">
					<div class="sf-account-form__input">
						<!-- 다국어: 아이디를 입력해주세요. -->
						<span class="hd_head-18_1">Otp</span>
						<el-input
							:placeholder="getMessage_('SWCC001005')"
							v-model="otp"
							autocomplete="on"
							@keyup.enter.native="loginAction"
							@input="e => input(e, 'otp')"
						/>
					</div>
				</div>
			</div>

			<div class="sf-account-form__item">
				<div class="col-lg-10">
					<div class="sf-account-form__btn">
						<!--  다국어: 로그인 -->
						<button type="button" @click="loginAction" class="hd_head-20_1">{{ getMessage_('SWCC000457') }}</button>
					</div>
				</div>
			</div>

			<div class="sf-account-form__item">
				<div class="col-lg-10">
					<div class="sf-account-form__util">
						<span @click="$router.push('/initPassword').catch(() => {})" class="pw_search hd_text-18_1">{{
							getMessage_('SWCC000458')
						}}</span>
					</div>
				</div>
			</div>

			<div class="sf-account-form__copyright">
				<div class="hd_text-12_1" style="color: #ffffffcc;">{{ copyright }}</div>
				<div class="hd_text-12_2"><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ffffffcc;">{{ icpNo }}</a></div>
			</div>
		</div>
	</div>
</template>

<script>
//사용자 로그인 페이지

//moment의 다국어 처리를 위한 설정들 import
import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';

//el-element의 다국어 처리를 위한 설정들 import
import locale from 'element-ui/lib/locale';
import koLocale from 'element-ui/lib/locale/lang/ko';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

import * as yup from 'yup';

import { rootComputed, rootMethods } from '@/store/common/helpers';

import DefaultLayout from '@/views/Layout/DefaultLayout';
import MenuLayout from '@/views/Layout/Main/MenuLayout';
import ScreenLayout from '@/views/Layout/Main/ScreenLayout';

export default {
	created() {
		//쿠키에 언어정보가 있으면 언어 값 셋팅
		if (this.getCookie('language') !== '') {
			this.language = this.getCookie('language');
		}

		//다국어 메세지 정보가 없다면
		if (!this.userMessage || !this.userMessage.size) {
			this.getLangMessage(this.language); //로그인 페이지 다국어 적용을 위한 초기 셋팅
		}
	},

	data() {
		return {
			language: 'ko_KR', //언어
			userId: '', //사용자 아이디
			userPw: '', //사용자 비밀번호
			otp: ''
		};
	},
	computed: {
		...rootComputed,

		systemName() {
			return process.env.VUE_APP_SYSTEM_NAME;
		},

		copyright() {
			return process.env.VUE_APP_COPYRIGHT;
		},

		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		},

		languageList() {
			return [
				{ label: this.getMessage_('SWCC000462'), value: 'ko_KR' }, //다국어: 한국어
				{ label: this.getMessage_('SWCC000464'), value: 'en_US' }, //다국어: 영어
				{ label: this.getMessage_('SWCC000463'), value: 'zh_CH' } //다국어: 중국어
			];
		},

		schema() {
			return yup.object().shape({
				userId: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000359')])), //{0}은(는) 팔수 입력 값 입니다. , ID
				userPw: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000758')])) //{0}은(는) 팔수 입력 값 입니다. , 비밀번호
			});
		}
	},

	watch: {
		//언어 변경 감시
		language(newVal) {
			this.getLangMessage(newVal); //변경된 언어로 다국어 메세지 리스트 요청
		}
	},

	methods: {
		...rootMethods,

		//input 한글 입력 방지
		input(e, target) {
			this[target] = e.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
		},

		//Cookie Setter 함수
		setCookie(key, value) {
			document.cookie = `${key}=${value}`;
		},

		//Cookie Getter 함수
		getCookie(key) {
			var cook = document.cookie + ';';
			var idx = cook.indexOf(key, 0);
			var val = '';

			if (idx != -1) {
				cook = cook.substring(idx, cook.length);
				var begin = cook.indexOf('=', 0) + 1;
				var end = cook.indexOf(';', begin);
				val = unescape(cook.substring(begin, end));
			}

			return val;
		},

		//선택한 언어를 이용해 다국어 리스트 요청
		getLangMessage(langCd) {
			this.$sf_toggleLoading(true);

			//선택한 언어를 이용해 다국어 리스트를 요청하는 Action 호출
			this.getLangMessage_({ langCd })
				.then(header => {
					//실패 시에만 에러 toast 창 알림
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					//302 에러로 인해 에러창이 발생하여, 임시로 주석처리 함
					// this.$sf_toast({
					// 	type: 'error',
					// 	message: error.message
					// });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//로그인 버튼 클릭시
		loginAction() {
			try {
				this.userId = this.userId.trim(); //아이디 앞뒤 공백 제거
				this.userPw = this.userPw.trim(); //비밀번호 앞뒤 공백 제거
				this.otp = this.otp.trim(); //otp
				this.schema.validateSync({ userId: this.userId, userPw: this.userPw, otp: this.otp }); //유효성 검사 체크
				this.login(); //로그인 함수 호출
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//사용자 로그인
		login() {
			//사용자 로그인 Action 호출
			this.$sf_toggleLoading(true);
			this.login_({
				userId: this.userId + ':===:1', //첫 로그인 시도 flag :1
				userPw: this.userPw ,
				otp: this.otp
			})
				.then(header => {
					this.loginResult(header); //로그인 결과 처리 로직
				})
				.catch(error => {
					this.$sf_showMessage({
						title: 'Error',
						icon: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//로그인 결과 처리
		loginResult(header) {
			switch (header.code) {
				case 0: //로그인 성공한 경우
					this.loginSuccess(); //로그인 성공 처리
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
					break;
				case -1: //이미 로그인(중복) 된 경우 -> 재 로그인 여부 묻기
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						title: 'Warning',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message,
						buttons: [
							//중복 로그인 시도
							{
								title: this.getMessage_('SWCC000457'),
								clickFn: () =>
									//사용자 로그인 Action 호출
									{
										this.$sf_toggleLoading(true);
										this.login_({
											userId: this.userId + ':===:0', // 중복 로그인 시도 flag: 0
											userPw: this.userPw,
											otp: this.otp
										})
											.then(header => {
												this.loginResult(header); //로그인 결과 처리
											})
											.catch(error => {
												this.$sf_showMessage({
													title: 'Error',
													icon: 'error',
													message: error.message
												});
											})
											.finally(() => {
												this.$sf_toggleLoading(false);
											});
									}
							}
						]
					});
					break;
				case 2: // 비밀번호 유효기간 만료한 경우
					this.defaultAssign_({ key: 'user', value: { userId: window.btoa(this.userId) } }); // 비밀번호 변경 페이지 셋팅 UserId

					this.$sf_showMessage({
						title: 'Error',
						icon: 'error ',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message, //다국어: 비밀번호 유효기간이 만료되었습니다. 비밀번호를 재설정 해주세요',
						closeFn: () => this.$router.push('/reset').catch(() => {}) //비밀번호 변경 페이지로 이동
					});
					break;
				case 4: // 비밀번호 5회 이상 오류난 경우
					this.defaultAssign_({ key: 'user', value: { userId: window.btoa(this.userId) } }); // 비밀번호 변경 페이지 셋팅 UserId

					this.$sf_showMessage({
						title: 'Error',
						icon: 'error ',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message, //다국어: 비밀번호 유효기간이 만료되었습니다. 비밀번호를 재설정 해주세요',
						closeFn: () => {
							this.defaultAssign_({ key: 'isLogout', value: true }); // 비밀번호 변경 후 로그아웃 시도 X -> 추후 제거 예정
							this.$router.push('/reset').catch(() => {});
						} //비밀번호 변경 페이지로 이동
					});

					this.$router.push('/reset').catch(() => {}); //재설정 페이지로 이동
					break;
				case 5: // 비밀번호가 초기화된 경우
					this.defaultAssign_({ key: 'user', value: { userId: window.btoa(this.userId) } }); // 비밀번호 변경 페이지 셋팅 UserId

					this.$sf_showMessage({
						title: 'Error',
						icon: 'error ',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message, //다국어: 비밀번호 유효기간이 만료되었습니다. 비밀번호를 재설정 해주세요',
						closeFn: () => {
							this.$router.push('/reset').catch(() => {}); //재설정 페이지로 이동
						} //비밀번호 변경 페이지로 이동
					});
					break;
				
				default:
					//3: error, 4: timeout
					this.$sf_showMessage({
						title: 'Error',
						icon: 'error',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
					break;
			}
		},

		//로그인 성공 처리 함수
		loginSuccess() {
			document.body.setAttribute('data-theme', this.topSkin); //사용자 색상 테마 적용
			document.body.setAttribute('font-theme', this.font); //사용자 폰트 테마 적용

			this.setCookie('language', this.language); //언어 쿠키에 저장

			this.$sf_toggleLoading(true);

			//사용자 언어 변경 Action 호출(로그인 화면의 언어로 사용자 언어 설정)
			this.updateLangCd_({ langCd: this.language })
				.then(header => {
					//사용자 언어 변경 성공 시
					if (header.code === 0) {
						//바뀐 언어에 맞게 el-element 의 다국어 변경
						switch (this.language) {
							case 'ko_KR':
								moment.locale('ko');
								locale.use(koLocale);
								break;
							case 'en_US':
								moment.locale('en');
								locale.use(enLocale);
								break;
							case 'zh_CH':
								moment.locale('zh_cn');
								locale.use(zhLocale);
								break;
							default:
								moment.locale('en');
								locale.use(enLocale);
								break;
						}
						Vue.use(vueMoment, { moment });
					}

					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
					this.createRoute(); //로그인 응답으로 Menu 정보가 Store에 셋팅된 상태, 그 정보를 이용해 Route 정보 생성
				});
		},

		//store의 메뉴 정보를 이용해 route 생성하는 함수
		createRoute() {
			if (this.menuMap.size > 0) {
				let route = {
					path: '/',
					name: '',
					redirect: '/login',
					component: DefaultLayout,
					children: []
				};

				for (let menu of this.menuMap.values()) {
					//tab을 사용하지않는 화면일 경우 자식 Routing 방식 사용
					//자식 Routing의 Name은 메뉴 Name에 Screen을 붙여서 관리
					//자식 Route에 보여줄 화면 은 scrId url Parameter를 통해 받아서 관리/Display
					let children = [];
					children.push({ path: `${menu.scrUrl}/:scrId`, name: `${menu.scrName}Screen`, component: ScreenLayout });

					//메뉴 정보와 생성한 자식 Route 정보를 route.children에 추가
					route.children.push({ path: menu.scrUrl, name: menu.scrName, component: MenuLayout, children });
				}

				this.$router.addRoute(route); //메뉴 정보들을 통해 생성한 Route 정보를 router에 추가
				this.$router.push(this.homeUrl).catch(() => {}); //home 화면 이동
			}
		}
	}
};
</script>

<style></style>
